import { SortDirection } from 'shared/newEntities/common';

import {
  OperatorAnalyticsChannelGroupByServer,
  OperatorAnalyticsGranularityServer
} from './server';

export {
  OperatorAnalyticsGranularityServer as OperatorAnalyticsGranularity,
  OperatorAnalyticsChannelGroupByServer as OperatorAnalyticsChannelGroupBy
} from './server';

/** Страницы раздела «Обращения» */
export enum OperatorAnalyticsPage {
  overview = 'overview',
  operators = 'operators',
  quality = 'quality',
  channels = 'channels',
  tags = 'tags'
}

/** Полуоткрытый интервал `[start, end)` в границах таймзоны проекта. */
export interface IOperatorAnalyticsPeriod {
  start: Date;
  end: Date;
}

export interface IOperatorAnalyticsCoverage {
  assignmentsFrom: Date | null;
  assignmentsEstimatedFrom: Date | null;
  firstResponseExactFrom: Date | null;
  firstResponseEstimatedFrom: Date | null;
  slaFrom: Date | null;
}

export interface IOperatorAnalyticsMeta {
  dataAsOf: Date;
  projectionLagSeconds: number;
  coverage: IOperatorAnalyticsCoverage | null;
}

export interface IOperatorAnalyticsPoint {
  at: Date;
  value: number | null;
}

export interface IOperatorAnalyticsMetric {
  total: number | null;
  points: IOperatorAnalyticsPoint[];
}

export interface IOperatorAnalyticsOverview {
  granularity: OperatorAnalyticsGranularityServer;
  newTickets: IOperatorAnalyticsMetric;
  closedTickets: IOperatorAnalyticsMetric;
  firstResponseSeconds: IOperatorAnalyticsMetric;
  slaViolationPercent: IOperatorAnalyticsMetric;
  slaEnabled: boolean | null;
  meta: IOperatorAnalyticsMeta;
}

export interface IOperatorAnalyticsOperator {
  id: string;
  name: string;
  deleted: boolean;
  assignedTickets: number;
  closedTickets: number;
  firstResponseSeconds: number | null;
  slaViolationPercent: number | null;
  csatAverage: number | null;
}

/** Колонки таблицы операторов, по которым доступна сортировка. */
export enum OperatorAnalyticsOperatorsSortColumn {
  name = 'name',
  assigned = 'assigned',
  closed = 'closed',
  firstResponse = 'firstResponse',
  slaViolation = 'slaViolation',
  csat = 'csat'
}

export { SortDirection as OperatorAnalyticsSortDirection };

/** `null` — порядок backend: `closed_tickets DESC, name ASC`. */
export interface IOperatorAnalyticsOperatorsSort {
  column: OperatorAnalyticsOperatorsSortColumn;
  direction: SortDirection;
}

export interface IOperatorAnalyticsChannelOption {
  id: string;
  name: string;
  kind: string;
  deleted: boolean;
}

export interface IOperatorAnalyticsSeries {
  id: string;
  name: string;
  total: number;
  points: IOperatorAnalyticsPoint[];
}

export interface IOperatorAnalyticsChannels {
  granularity: OperatorAnalyticsGranularityServer;
  groupBy: OperatorAnalyticsChannelGroupByServer;
  total: number;
  channels: IOperatorAnalyticsChannelOption[];
  series: IOperatorAnalyticsSeries[];
  meta: IOperatorAnalyticsMeta;
}

export interface IOperatorAnalyticsTagRow {
  id: string;
  name: string;
  newTickets: number;
}

export interface IOperatorAnalyticsTags {
  granularity: OperatorAnalyticsGranularityServer;
  tags: IOperatorAnalyticsTagRow[];
  series: IOperatorAnalyticsSeries[];
  meta: IOperatorAnalyticsMeta;
}

export interface IOperatorAnalyticsQualityOperator {
  id: string;
  name: string;
  deleted: boolean;
}

export interface IOperatorAnalyticsQualityItem {
  ticketId: number;
  conversationId: number;
  firstMessageId: string | null;
  dateClosed: Date;
  userName: string;
  channel: IOperatorAnalyticsChannelOption | null;
  operator: IOperatorAnalyticsQualityOperator | null;
  rating: number | null;
  comment: string | null;
}

export interface IOperatorAnalyticsQualitySummary {
  enabled: boolean;
  average: number | null;
  ratedCount: number;
  closedCount: number;
  distribution: Record<OperatorAnalyticsRating, number>;
}

export interface IOperatorAnalyticsQualityPage {
  summary: IOperatorAnalyticsQualitySummary;
  items: IOperatorAnalyticsQualityItem[];
  nextCursor: string | null;
  meta: IOperatorAnalyticsMeta;
}

/** Оценка CSAT: 1..5. */
export type OperatorAnalyticsRating = 1 | 2 | 3 | 4 | 5;

/** Иерархический выбор каналов: тип канала со своими каналами. */
export interface IOperatorAnalyticsChannelKindGroup {
  kind: string;
  channels: IOperatorAnalyticsChannelOption[];
}
